import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { EngagementFYEEmployeeLinkContainerModel } from '../../../../../../models/aggregates/erp/engagement';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config} from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class EngagementFyeEmployeeMultipleLinksService extends BaseApiTemplateService<EngagementFYEEmployeeLinkContainerModel[]> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.ENGAGEMENT_PREFIX + 'fye-employee-links/multiple/backoffice-ep';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.ENGAGEMENT_PREFIX + 'fye-employee-links/multiple/backoffice-ep';
    this.httpClient = http;
  }

  deleteMultipleLinks(guids: string[], visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        authorization: visa.jwt_secret,
        tenantCode: visa.tenantCode
      }),
      body: guids
    };

    return this.httpClient.delete<BasicApiResponseModel<any>>(this.apiUrl, httpOptions);
  }

}
